/* a1af2e8d57e593ba4ac657675f0018a8c58c87aa
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProfileAuthorizedUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProfileAuthorizedUserQuery = { __typename?: 'Query', authUser?: { __typename?: 'User', id?: string | null, email?: string | null, phone?: string | null, phoneNumber?: string | null, phoneNumberInternationalFormatted?: string | null, phonePrefix?: number | null, phoneCountry?: string | null, phoneValid?: boolean | null, firstname?: string | null, lastname?: string | null, photo?: string | null, accountType?: Types.AccountType | null, address?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zip?: string | null, photoFilenameSmall?: string | null, photoFilenameBig?: string | null, yearBorn?: number | null, pets?: string | null, familyMembers?: number | null, workplace?: string | null, education?: Types.Education | null, note?: string | null, smoker?: boolean | null, timeAccountUpgraded?: any | null, timeAccountExpiration?: any | null, timePasswordUpdated?: any | null, premium?: boolean | null, watchdogCount?: string | null, manualInvoices?: boolean | null, locale?: Types.Locale | null, isOwner?: boolean | null, walletBalance?: number | null, walletCurrency?: Types.Currency | null, isLegalEntity?: boolean | null, type?: Types.UserGroupType | null, timeCreated?: any | null, phoneVerified?: boolean | null, userGroup?: { __typename?: 'UserGroup', id?: string | null, type?: Types.UserGroupKeyType | null, name?: string | null, ic?: string | null, dic?: string | null } | null, creditcheck?: { __typename?: 'Creditcheck', id?: string | null, locale?: Types.Locale | null, executionEvidence?: Types.CreditcheckStatus | null, insolvencyRegister?: Types.CreditcheckStatus | null, addressMatch?: Types.CreditcheckStatus | null, executionSkov?: Types.CreditcheckStatus | null, bankruptcy?: Types.CreditcheckStatus | null, rnDb?: Types.CreditcheckStatus | null, dph?: Types.CreditcheckStatus | null, debtSp?: Types.CreditcheckStatus | null, debtVzp?: Types.CreditcheckStatus | null, idValid?: Types.CreditcheckStatus | null, skUrad?: Types.CreditcheckStatus | null, hledaniPcr?: Types.CreditcheckStatus | null, requestLocale: Types.Locale, requestFirstName?: string | null, requestLastName?: string | null, requestDateBirth?: string | null, requestStreet?: string | null, requestStreetNumber?: string | null, requestCity?: string | null, requestZip?: string | null, requestIdType?: Types.CreditcheckIdType | null, requestIdNumber?: string | null, timeCreated?: any | null, reportUrl?: string | null } | null, tipInfo?: { __typename?: 'UserTipInfo', hasAdvert?: boolean | null, hasPragueRentAdvert?: boolean | null, hasPragueSaleAdvert?: boolean | null, hasActiveAdvertRent?: boolean | null, hasActiveAdvertSale?: boolean | null, hasRentPlatformAdvert?: boolean | null, shouldBuyRentContract?: boolean | null, shouldBuySaleContract?: boolean | null, hasAdvertService?: boolean | null, shouldShowTvujSpravce?: boolean | null, shouldShowTvujSpravceInactive?: boolean | null, shouldShowTvujSpravceWithReactions?: boolean | null, shouldShowTvujSpravce21days?: boolean | null, hasAnyAdvertComfort?: boolean | null, hasActiveAdvertComfort?: boolean | null, respondedToSale?: boolean | null, hasActiveAdvertComfortWithReactions?: boolean | null, mortgageRate?: number | null } | null } | null };


export const ProfileAuthorizedUserDocument = gql`
    query ProfileAuthorizedUser {
  authUser {
    id
    email
    phone
    phoneNumber
    phoneNumberInternationalFormatted
    phonePrefix
    phoneCountry
    phoneVerified: phoneValid
    phoneValid
    firstname
    lastname
    photo(filter: USER_PHOTO)
    accountType
    address
    street
    streetNumber
    city
    zip
    photoFilenameSmall
    photoFilenameBig
    yearBorn
    pets
    familyMembers
    workplace
    education
    note
    smoker
    timeAccountUpgraded
    timeAccountExpiration
    timePasswordUpdated
    premium
    watchdogCount
    manualInvoices
    locale
    isOwner
    walletBalance
    walletCurrency
    isLegalEntity
    type
    timeCreated
    userGroup {
      id
      type
      name
      ic
      dic
    }
    creditcheck {
      id
      locale
      executionEvidence
      insolvencyRegister
      addressMatch
      executionSkov
      bankruptcy
      rnDb
      dph
      debtSp
      debtVzp
      idValid
      skUrad
      hledaniPcr
      requestLocale
      requestFirstName
      requestLastName
      requestDateBirth
      requestStreet
      requestStreetNumber
      requestCity
      requestZip
      requestIdType
      requestIdNumber
      timeCreated
      reportUrl
    }
    tipInfo {
      hasAdvert
      hasPragueRentAdvert
      hasPragueSaleAdvert
      hasActiveAdvertRent
      hasActiveAdvertSale
      hasRentPlatformAdvert
      shouldBuyRentContract
      shouldBuySaleContract
      hasAdvertService
      shouldShowTvujSpravce
      shouldShowTvujSpravceInactive
      shouldShowTvujSpravceWithReactions
      shouldShowTvujSpravce21days
      hasAnyAdvertComfort
      hasActiveAdvertComfort
      respondedToSale
      hasActiveAdvertComfortWithReactions
      mortgageRate
    }
  }
}
    `;

/**
 * __useProfileAuthorizedUserQuery__
 *
 * To run a query within a React component, call `useProfileAuthorizedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileAuthorizedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileAuthorizedUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileAuthorizedUserQuery(baseOptions?: Apollo.QueryHookOptions<ProfileAuthorizedUserQuery, ProfileAuthorizedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileAuthorizedUserQuery, ProfileAuthorizedUserQueryVariables>(ProfileAuthorizedUserDocument, options);
      }
export function useProfileAuthorizedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileAuthorizedUserQuery, ProfileAuthorizedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileAuthorizedUserQuery, ProfileAuthorizedUserQueryVariables>(ProfileAuthorizedUserDocument, options);
        }
export type ProfileAuthorizedUserQueryHookResult = ReturnType<typeof useProfileAuthorizedUserQuery>;
export type ProfileAuthorizedUserLazyQueryHookResult = ReturnType<typeof useProfileAuthorizedUserLazyQuery>;
export type ProfileAuthorizedUserQueryResult = Apollo.QueryResult<ProfileAuthorizedUserQuery, ProfileAuthorizedUserQueryVariables>;